//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "predict-list",
  data(){
    return{
      wrapperHeight:0,
      allLoaded:false,
      config:{
        title:'预测协同',
        url:'api/prediction/page',
        property: "createdDate",
        inputCondition:{
          placeholder:'供应商/物料/工厂',
          searchCondition:'key',
          rules:[{field:"supplier.supplierName-supplier.supplierCode-material.matName-material.matCode-plant.plantName-plant.plantCode", option: "LIKE_ANYWHERE"}]
        }
      },
      list:[]
    }
  },
  methods:{
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function() {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop(){
      this.$refs.header.getlist(true);
    },
    loadBottom(){
      this.$refs.header.getMore();
    }
  },
  mounted(){
    this.init();
    this.$refs.header.getlist();
  }
}



// WEBPACK FOOTER //
// ./src/page/procu-syner/predict-list.vue